import { api } from '../../shared/api/client';
import type { Membership } from '../../shared/api/types';
import { useAsync } from '../../shared/ui/useAsync';
import { formatDay } from '../admin/AdminChurchesPage';
import { useLiveVersion } from '../../shared/live';

type Mine = Membership & { churchName: string };

/** Mis solicitudes de membresía que esperan respuesta de la iglesia. */
export function useMyPendingRequests(version = 0) {
  const live = useLiveVersion((e) => e.kind.startsWith('membership'));
  return useAsync((signal) => api.get<{ items: Mine[] }>('/multichurch/me/memberships', signal).then((r) => r.items.filter((m) => m.status === 'pending')), [version, live]);
}

/** Mis solicitudes rechazadas (las de los últimos 30 días), con el motivo que escribió la iglesia. */
export function RejectedRequests() {
  const live = useLiveVersion((e) => e.kind.startsWith('membership'));
  const data = useAsync(
    (signal) =>
      api
        .get<{ items: Mine[] }>('/multichurch/me/memberships', signal)
        .then((r) => r.items.filter((m) => m.status === 'rejected' && Date.now() - new Date(m.requested_at).getTime() < 30 * 86_400_000)),
    [live],
  );
  if (data.status !== 'ready' || data.data.length === 0) return null;
  return (
    <ul className="list" aria-label="Solicitudes no aprobadas">
      {data.data.map((m) => (
        <li key={m.id} className="list__item">
          <span>
            <strong>{m.churchName || 'Iglesia'}</strong> <span className="badge badge--warn">No aprobada</span>
            {m.end_reason ? <span className="small"> · Motivo: {m.end_reason}</span> : null}
          </span>
        </li>
      ))}
    </ul>
  );
}

/** Aviso visible: "Solicitud enviada a … · Pendiente de aprobación". */
export function PendingRequests({ version = 0 }: { version?: number }) {
  const pending = useMyPendingRequests(version);
  if (pending.status !== 'ready' || pending.data.length === 0) return null;
  return (
    <ul className="list pending-requests" aria-label="Solicitudes pendientes">
      {pending.data.map((m) => (
        <li key={m.id} className="list__item">
          <span>
            <strong>{m.churchName || 'Iglesia'}</strong>
            <span className="small muted"> · enviada el {formatDay(m.requested_at)}</span>
          </span>
          <span className="badge badge--pending">Pendiente de aprobación</span>
        </li>
      ))}
    </ul>
  );
}
